import { trackCDNPerformance as trackCDNPerformance$1 } from "./events.mjs";
function getCDNPerformanceMetrics(cdnHostname) {
  try {
    const cdnResourceEntries = performance.getEntriesByType("resource").filter(
      (e) => new URL(e.name).hostname === cdnHostname
    );
    if (cdnResourceEntries.length === 0) {
      return;
    }
    const metrics = {
      cacheHitCount: 0,
      cacheHitRatio: 0,
      requestCount: cdnResourceEntries.length
    };
    let totalRequestTimeMs = 0;
    let totalTransferSizeBytes = 0;
    for (const entry of cdnResourceEntries) {
      let isBrowserCacheHit = false;
      if (entry.transferSize === void 0 || entry.encodedBodySize === void 0) {
        const requestDurationMs = entry.responseEnd - entry.requestStart;
        isBrowserCacheHit = requestDurationMs < 20;
      } else {
        isBrowserCacheHit = entry.encodedBodySize > 0 && entry.transferSize === 0;
      }
      if (isBrowserCacheHit) {
        metrics.cacheHitCount += 1;
      } else {
        totalRequestTimeMs += entry.responseEnd - entry.connectStart;
        totalTransferSizeBytes += entry.transferSize;
      }
    }
    metrics.cacheHitRatio = metrics.cacheHitCount / metrics.requestCount;
    const cacheMissCount = metrics.requestCount - metrics.cacheHitCount;
    if (cacheMissCount > 0) {
      metrics.requestTimeAverageMs = Math.round(
        totalRequestTimeMs / cacheMissCount
      );
      if (!Number.isNaN(totalTransferSizeBytes)) {
        metrics.transferSizeAverageBytes = Math.round(
          totalTransferSizeBytes / cacheMissCount
        );
      }
    }
    return metrics;
  } catch (error) {
    console.warn("Skipping CDN performance metrics:", error);
  }
}
function trackCDNPerformance() {
  const cdnPerformanceMetrics = getCDNPerformanceMetrics(location.hostname);
  if (cdnPerformanceMetrics) {
    trackCDNPerformance$1(cdnPerformanceMetrics);
  }
}
export {
  trackCDNPerformance
};
